import {IArticle} from '../../service/airiflow';
import {updateQueryString} from './url';
import {commonParamBuilder} from '../../lib/paramBuilder';
import queryString from 'query-string';

export function loadNewsItem(urlObj, forbidLoad) {
  const ucapi = window.ucapi;
  ucapi.alphaNews.loadNewsItem(Object.assign({
    success: (data) => {
      if ((data && data.is_loadurl) || forbidLoad) {
        return;
      }
      window.location = urlObj.url;
    },
    fail: () => {
      if (forbidLoad) {
        return;
      }
      window.location = urlObj.url;
    },
  }, urlObj));
}

// should use this
export const openNewsUrl = (urlObj) => {
  console.log('openNewsUrl', JSON.stringify(urlObj, null, 4));
  const ucapi = window.ucapi;
  try {
    if ((urlObj.content_type === 4 || urlObj.item_type === 208)) { // 视频页面。如果是栏目里的话，客户端暂不注入，要注入请找荩臣。
      ucapi.video.clickRelatedVideo(Object.assign({
        success: () => {
          // nothing
        },
        fail: loadNewsItem,
      }, urlObj));
    } else { // 普通页面
      ucapi.alphaNews.clickRelatedArticle(Object.assign({
        success: (res) => {
          console.log('success', res);
        },
        fail: (err) => {
          console.log('error', err);
          window.location = urlObj.url;
        },
      }, urlObj));
    }
  } catch (ex) {
    console.error(ex);
    window.location = urlObj.url;
  }
};

export function getOpenParamForArticle(article: IArticle, willAppendCurrentPageCommonParams: boolean) {

  /* 其中，
    uc_biz_str=action:base.openwindow|param:S.object=infoflow;S.token=1002;S.scene=1002;l.channel=101;S.cfg=comment;end
    就是biz协议。
    如果不想返回到列表页，把这个参数去掉。  */
  let url = updateQueryString('uc_biz_str', null, article.url);

  if (willAppendCurrentPageCommonParams) {
    // 加入当前页面已有的公参等，url中的参数优先级更高
    const commonParams = commonParamBuilder.getParams(queryString.parse(location.search, {arrayFormat: 'bracket'}));
    const {url: urlNoParam, query} = queryString.parseUrl(url, {arrayFormat: 'bracket'});
    url = urlNoParam + '?' + queryString.stringify(Object.assign(commonParams, query), {arrayFormat: 'bracket'});
  }

  let obj = {
    url,
    // 'id': raw.id,
    // 'item_id': raw.id,
    source_name: article.source_name,
    seed_icon_url: article.seed_icon_url,
    seed_icon_desc: article.seed_icon_desc,
    // 'content_type': raw.content_type,
    // 'comment_type': raw.comment_type,
    // 'item_type': raw.item_type,
    // 'comment_stat': raw.comment_stat || 1,
    comment_ref_id: article.comment_ref_id,
    // 'overtime': raw.overtime || (Date.now() / 1000 + config.video.custom.overTime),
    // 'abtag': raw.abtag || '',
    style_type: article.style_type || 0,
    // 'recoid': raw.recoid || '',
    daoliu_type: article.daoliu_type || 0,
    summary: article.summary || '',
    // 'img_url':  raw.thumbnail && raw.thumbnail.length > 0 ? raw.thumbnail[0].url : null,
    lang: article.ct_lang || '',

    // seed_icon_desc: '',
    // seed_icon_url: '',
    people_id: '',
    cp_info: article.cp_info || {},
    // content: raw.content,
    title: article.title,
    item_id: article.id,
    article_id: article.id,
    item_type: article.item_type,
    comment_stat: article.comment_stat || 0,
    comment_type: article.comment_type || 0,
    content_type: article.content_type,
    id: article.id,

    // thumbnail
    ...((article.thumbnails && article.thumbnails.length > 0) ? {img_url: article.thumbnails[0].url} : null),

  };

  if (article.videos && article.videos.length > 0) {
    const video = article.videos[0];

    obj = Object.assign({
      video_source: video.source,          // 视频的来源
      video_url: video.url,                 // 视频的url
      play_id: video.play_id || video.id,
      player_type: video.player_type,
      ch_id: '',
      video_id: video.id,
      // icon : video.originalSaveUrl,
    }, obj);
  }

  if (url) {
    const {query} = queryString.parseUrl(url, {arrayFormat: 'bracket'});
    obj = Object.assign(obj, query);
  }
  return obj;
}

export function openNewsWithArticle(article: IArticle, willAppendCurrentPageCommonParams?: boolean) {
  openNewsUrl(getOpenParamForArticle(article, willAppendCurrentPageCommonParams));
}
